<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{ 'Add Guest' | translate }}</h4>
  </div>
  <div class="modal-body">
    <form
      class="row"
      novalidate
      (ngSubmit)="onSave()"
      [formGroup]="guestbookForm"
    >
      <div class="col-auto">
        <div class="form-group">
          <select
            type="text"
            class="form-control"
            tabindex="0"
            id="propertyId"
            formControlName="propertyId"
            [class.is-invalid]="
              sent && guestbookForm.get('propertyId').hasError('required')
            "
          >
            <option [value]="property.id" *ngFor="let property of properties">
              {{ property.name }}
            </option>
          </select>

          <div
            class="invalid-feedback animate-show animate-fast"
            *ngIf="sent && guestbookForm.get('propertyId').hasError('required')"
          >
            {{ 'global.validators.required.error' | translate }}
          </div>
        </div>
      </div>

      <hr class="w-100" />

      <div class="col">
        <div class="row">
          <div class="col-md-4">
            <div class="row">
              <div class="col-8">
                <div class="form-group">
                  <label for="checkintime" class="form-label">
                    {{ 'Check In' | translate }}
                  </label>
                  <div class="input-group">
                    <input
                      class="form-control"
                      tabindex="0"
                      id="checkintime"
                      ngbDatepicker
                      #d1="ngbDatepicker"
                      readonly
                      formControlName="checkintime"
                      [class.is-invalid]="
                        sent &&
                        guestbookForm.get('checkintime').hasError('required')
                      "
                    />
                    <div class="input-group-append">
                      <button
                        tabindex="0"
                        class="btn btn-outline-secondary"
                        type="button"
                        (click)="d1.toggle()"
                      >
                        <i class="fe fe-sm fe-calendar"></i>
                      </button>
                    </div>
                  </div>

                  <div
                    class="invalid-feedback animate-show animate-fast"
                    *ngIf="
                      sent &&
                      guestbookForm.get('checkintime').hasError('required')
                    "
                  >
                    {{ 'global.validators.required.error' | translate }}
                  </div>
                </div>
              </div>
              <div class="col-4 pl-0">
                <div class="form-group">
                  <label for="checkintimeTime" class="form-label">&nbsp;</label>
                  <input
                    type="text"
                    class="form-control text-center"
                    formControlName="checkintimeTime"
                    id="checkintimeTime"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="row">
              <div class="col-8">
                <div class="form-group">
                  <label for="checkouttime" class="form-label">
                    {{ 'Check Out' | translate }}
                  </label>
                  <div class="input-group">
                    <input
                      class="form-control"
                      tabindex="0"
                      id="checkouttime"
                      ngbDatepicker
                      #d2="ngbDatepicker"
                      readonly
                      formControlName="checkouttime"
                      [class.is-invalid]="
                        sent &&
                        guestbookForm.get('checkouttime').hasError('required')
                      "
                    />
                    <div class="input-group-append">
                      <button
                        tabindex="0"
                        class="btn btn-outline-secondary"
                        type="button"
                        (click)="d2.toggle()"
                      >
                        <i class="fe fe-sm fe-calendar"></i>
                      </button>
                    </div>
                  </div>

                  <div
                    class="invalid-feedback animate-show animate-fast"
                    *ngIf="
                      sent &&
                      guestbookForm.get('checkouttime').hasError('required')
                    "
                  >
                    {{ 'global.validators.required.error' | translate }}
                  </div>
                </div>
              </div>
              <div class="col-4 pl-0">
                <div class="form-group">
                  <label for="checkouttimeTime" class="form-label"
                    >&nbsp;</label
                  >
                  <input
                    type="text"
                    class="form-control text-center"
                    formControlName="checkouttimeTime"
                    id="checkouttimeTime"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-3 offset-md-1">
            <div class="form-group text-center">
              <label for="nights" class="form-label">
                {{ 'Nights' | translate }}
              </label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <button
                    tabindex="0"
                    [disabled]="guestbookForm.get('nights').value < 1"
                    class="btn btn-outline-secondary"
                    type="button"
                    (click)="onChangeNights(-1)"
                  >
                    <i class="fe fe-sm fe-minus"></i>
                  </button>
                </div>
                <input
                  type="text"
                  class="form-control text-center"
                  tabindex="0"
                  id="nights"
                  formControlName="nights"
                />
                <div class="input-group-append">
                  <button
                    tabindex="0"
                    class="btn btn-outline-secondary"
                    type="button"
                    (click)="onChangeNights(1)"
                  >
                    <i class="fe fe-sm fe-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="w-100" />

      <div class="col-md-5">
        <div class="form-group">
          <label for="firstName" class="form-label">
            {{ 'Name' | translate }}
          </label>
          <input
            #firstName
            type="text"
            class="form-control"
            tabindex="0"
            id="firstName"
            formControlName="firstName"
            [class.is-invalid]="
              sent && guestbookForm.get('firstName').hasError('required')
            "
          />

          <div
            class="invalid-feedback animate-show animate-fast"
            *ngIf="sent && guestbookForm.get('firstName').hasError('required')"
          >
            {{ 'global.validators.required.error' | translate }}
          </div>
        </div>

        <div class="form-group">
          <label for="lastName" class="form-label">
            {{ 'Last name' | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            tabindex="0"
            id="lastName"
            formControlName="lastName"
            [class.is-invalid]="
              sent && guestbookForm.get('lastName').hasError('required')
            "
          />

          <div
            class="invalid-feedback animate-show animate-fast"
            *ngIf="sent && guestbookForm.get('lastName').hasError('required')"
          >
            {{ 'global.validators.required.error' | translate }}
          </div>
        </div>
      </div>

      <div class="col-md-7">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="birthDate" class="form-label">
                {{ 'Date of birth' | translate }}
              </label>
              <div class="input-group">
                <input
                  class="form-control"
                  tabindex="0"
                  id="birthDate"
                  ngbDatepicker
                  #d3="ngbDatepicker"
                  (click)="d3.toggle()"
                  [minDate]="minBirthDate"
                  readonly
                  formControlName="birthDate"
                  [class.is-invalid]="
                    sent && guestbookForm.get('birthDate').hasError('required')
                  "
                />
                <div class="input-group-append">
                  <button
                    tabindex="0"
                    class="btn btn-outline-secondary"
                    type="button"
                    (click)="d3.toggle()"
                  >
                    <i class="fe fe-sm fe-calendar"></i>
                  </button>
                </div>
              </div>

              <div
                class="invalid-feedback animate-show animate-fast"
                *ngIf="
                  sent && guestbookForm.get('birthDate').hasError('required')
                "
              >
                {{ 'global.validators.required.error' | translate }}
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label for="gender" class="form-label">
                {{ 'Gender' | translate }}
              </label>
              <select
                class="form-control"
                tabindex="0"
                id="gender"
                formControlName="gender"
                [class.is-invalid]="
                  sent && guestbookForm.get('gender').hasError('required')
                "
              >
                <option value="M">{{ 'Male' | translate }}</option>
                <option value="F">{{ 'Female' | translate }}</option>
              </select>

              <div
                class="invalid-feedback animate-show animate-fast"
                *ngIf="sent && guestbookForm.get('gender').hasError('required')"
              >
                {{ 'global.validators.required.error' | translate }}
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="country" class="form-label">
            {{ 'Country' | translate }}
          </label>
          <input
            [ngbTypeahead]="searchCountries"
            [resultTemplate]="rt"
            [inputFormatter]="formatter"
            [editable]="false"
            class="form-control"
            tabindex="0"
            id="country"
            formControlName="countrySearch"
            (focus)="onFocusCountry()"
            [class.is-invalid]="
              sent && guestbookForm.get('country').hasError('required')
            "
          />

          <ng-template #rt let-r="result" let-t="term">
            <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
          </ng-template>

          <div
            class="invalid-feedback animate-show animate-fast"
            *ngIf="sent && guestbookForm.get('country').hasError('required')"
          >
            {{ 'global.validators.required.error' | translate }}
          </div>
        </div>
      </div>

      <hr class="w-100" />

      <div class="col">
        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <label for="documentType" class="form-label">
                {{ 'Document type' | translate }}
              </label>
              <select
                type="text"
                class="form-control"
                tabindex="0"
                id="documentType"
                formControlName="documentType"
                [class.is-invalid]="
                  sent && guestbookForm.get('documentType').hasError('required')
                "
              >
                <option
                  [value]="documentType.code"
                  *ngFor="let documentType of documentTypes"
                >
                  {{
                    documentType['caption' + (language === 'sl' ? '_sl' : '')]
                  }}
                </option>
              </select>

              <div
                class="invalid-feedback animate-show animate-fast"
                *ngIf="
                  sent && guestbookForm.get('documentType').hasError('required')
                "
              >
                {{ 'global.validators.required.error' | translate }}
              </div>
            </div>
          </div>
          <div class="col-md-7">
            <div class="form-group">
              <label for="documentNumber" class="form-label">
                {{ 'Document number' | translate }}
              </label>
              <input
                type="text"
                class="form-control"
                tabindex="0"
                id="documentNumber"
                formControlName="documentNumber"
                [class.is-invalid]="
                  sent &&
                  guestbookForm.get('documentNumber').hasError('required')
                "
              />

              <div
                class="invalid-feedback animate-show animate-fast"
                *ngIf="
                  sent &&
                  guestbookForm.get('documentNumber').hasError('required')
                "
              >
                {{ 'global.validators.required.error' | translate }}
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-auto">
            <div class="form-group">
              <label for="ttaxType" class="form-label">
                {{ 'Tourist tax' | translate }}
              </label>
              <select
                type="text"
                class="form-control"
                tabindex="0"
                id="documentType"
                formControlName="ttaxType"
                [class.is-invalid]="
                  sent && guestbookForm.get('ttaxType').hasError('required')
                "
              >
                <option
                  [value]="ttaxType.code"
                  *ngFor="let ttaxType of taxTypes"
                >
                  {{ ttaxType['caption' + (language === 'sl' ? '_sl' : '')] }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <hr class="w-100" />

        <div class="row">
          <div
            class="col"
            [class.col-md-6]="guestbook && guestbook.id && property"
          >
            <div class="row">
              <div class="col">
                <p class="text-nowrap">
                  {{ ttaxValue | pepCurrency: currencyId:activeOrg.locale }} /
                  {{ 'night' | translate }}
                </p>
                <p class="text-nowrap">
                  {{ 'Promo tax' | translate }}
                </p>
                <p class="text-nowrap font-weight-bold">
                  {{ 'Total' | translate }}
                </p>
              </div>
              <div class="col">
                <p class="text-nowrap">
                  {{ guestbookForm.get('nights').value }}
                  {{ 'nights' | translate }}
                </p>
                <p class="text-nowrap">
                  {{ guestbookForm.get('nights').value }}x
                </p>
                <p class="text-nowrap"></p>
              </div>
              <div class="col text-right">
                <p class="text-nowrap">
                  {{ ttaxTotal | pepCurrency: currencyId:activeOrg.locale }}
                </p>
                <p class="text-nowrap">
                  {{ promoTaxTotal | pepCurrency: currencyId:activeOrg.locale }}
                </p>
                <p class="text-nowrap font-weight-bold mb-0">
                  {{ total | pepCurrency: currencyId:activeOrg.locale }}
                </p>
              </div>
            </div>
          </div>

          <div
            class="col pl-md-5"
            *ngIf="guestbook && guestbook.id && property"
          >
            <div class="row">
              <div class="col">
                <p>{{ 'Saved on' | translate }}:</p>
                <p>{{ 'Last modified on' | translate }}:</p>
                <p>
                  {{
                    'Submitted to %authority% on'
                      | translate
                        : { authority: property.authorityType_caption }
                  }}:
                </p>
              </div>
              <div class="col text-right">
                <p class="text-nowrap">
                  {{ guestbook.createdTime | pepDate: activeOrg.locale:true }}
                </p>
                <p class="text-nowrap">
                  {{ guestbook.editedTime | pepDate: activeOrg.locale:true }}
                </p>
                <p class="mb-0">
                  {{ '???' }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button
      class="btn btn-outline-secondary"
      type="button"
      (click)="onClose()"
      [class.mr-auto]="!guestbook || !guestbook.id"
    >
      {{ 'Cancel' | translate }}
    </button>
    <button
      *ngIf="guestbook && guestbook.id"
      class="btn btn-outline-danger mr-auto"
      type="button"
      [disabled]="loading"
      (click)="onDelete()"
    >
      <i class="fe fe-trash"></i> {{ 'Delete' | translate }}
    </button>

    <button
      *ngIf="guestbook && guestbook.id"
      class="btn btn-outline-secondary"
      type="button"
      [disabled]="loading"
      (click)="onDuplicate()"
    >
      <i class="fe fe-copy"></i> {{ 'Duplicate' | translate }}
    </button>
    <button
      class="btn btn-primary"
      type="button"
      (click)="onSave()"
      [disabled]="loading"
    >
      <span *ngIf="!guestbook || !guestbook.id">{{ 'global.save' | translate }}</span>
      <span *ngIf="guestbook && guestbook.id">{{ 'Update' | translate }}</span>
      <span *ngIf="loading"
        >&nbsp; <i class="fa fa-spinner-third fa-spin fa-md fa-lg"></i
      ></span>
    </button>
  </div>
</div>
